import styled from "@emotion/styled";
import { css } from "@emotion/react";
import {
	StyledTab,
	StyledPillTabList,
	StyledUnderlineTabList,
	StyledInputContainer,
	StyledScrollAnchor,
	respondToRange,
	animation,
	keyframes,
	calc,
	StyledRadioButtons,
	StyledScrollContainer,
	StyledContainer,
	LengthValue,
	StyledLabel,
} from "@animech/ui";

export const Root = styled.div`
	${({ theme }) => {
		const cardWidth: LengthValue = "150px";

		const timingFunction = theme.animations.timingFunctions.default;
		const padding = theme.components.container.sizes.default.paddingVertical;
		const mobilePadding =
			theme.components.container.sizes.default.mobilePaddingVertical;

		return css`
			--card-width: minmax(${cardWidth}, calc(${cardWidth} * 1.2));
			display: flex;
			flex-direction: column;
			flex-grow: 1;
			height: 100%;
			background-color: ${theme.colors.backgrounds[0].background};
			backdrop-filter: blur(100px);
			box-sizing: border-box;
			margin-bottom: -12px;
			padding: ${theme.dimensions.margin.base};
			gap: 8px;

			/* This is a workaround to increase the gap between tab items */
			ul {
				gap: 32px;
			}

			${StyledRadioButtons.Root} {
				font-weight: 300;
				display: flex;
				flex-direction: row !important;
				align-items: center;
				justify-content: space-between;
				padding: 8px 0;

				${StyledRadioButtons.Item} {
					align-items: center;
					margin: 0 !important;

					${StyledRadioButtons.Label} {
						font-size: 16px;
					}
				}
			}

			${StyledRadioButtons.Label} {
				white-space: nowrap;
				font-weight: 300;
				font-size: ${theme.typography.fontSize.xxxLarge};
				color: #857d77 !important;
			}

			& input:checked ~ ${StyledRadioButtons.Label} {
				color: #101010 !important;
			}
			${StyledLabel.Root} {
				font-weight: 300;
				font-size: 18px;
			}

			${StyledScrollContainer.ScrollContainer} {
				margin: 0 ${theme.dimensions.margin.xLarge};
			}

			${StyledContainer.Root} {
				${StyledScrollContainer.ScrollContainer} {
					margin: 0;
				}
			}

			${StyledTab.Root} {
				${StyledUnderlineTabList.Root},
				${StyledPillTabList.Root} {
					${animation({
						keyframes: keyframes.slideInDown("100%"),
						duration: 250,
						delay: 100,
						timingFunction,
						fillMode: "backwards",
					})}

					> * {
						${animation({
							keyframes: keyframes.fadeIn(),
							duration: 150,
							delay: 250,
							timingFunction,
							fillMode: "backwards",
						})}
					}
				}

				${StyledInputContainer.Root} {
					${animation({
						keyframes: keyframes.fadeIn(),
						duration: 250,
						delay: 200,
						timingFunction,
						fillMode: "backwards",
					})}
				}

				${StyledScrollAnchor.Root} {
					margin-top: ${calc(padding, (n) => -n)};
					margin-bottom: ${theme.components.inputContainer.marginBottom};
					padding-top: ${padding};

					&:last-child {
						margin-bottom: 0;
					}
				}
			}

			${StyledRadioButtons.Root} {
				display: flex;
				background-color: ${theme.colors.backgrounds[2].background};
				flex-direction: row !important;
				align-items: center;
				gap: ${theme.dimensions.margin.base};

				${StyledRadioButtons.Item} {
					margin: 0 ${theme.dimensions.margin.base};
				}
			}

			${respondToRange(theme, "tablet", "down")} {
				${StyledTab.Root} {
					${StyledScrollAnchor.Root} {
						margin-top: ${calc(mobilePadding, (n) => -n)};
						padding-top: ${mobilePadding};
					}
				}
			}
		`;
	}}
`;
